import React from 'react';
import './_styles/index.scss';
import Spinner from './_Loader';
import Products from './Products';
import CheckoutForm from './Form';
import { createHmac } from 'crypto';
import { Helmet } from 'react-helmet';
import Cookies from 'universal-cookie';
import { Navigation } from 'components';

export default class Checkout extends React.Component {

  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.state={
      invoice: '',
      checkout: {}
    }
  }

  componentDidMount = () => {

    const session = this.cookies.get('session_data');

    const order_id = this.create_order_id(session);

    return this.setState({ invoice: order_id });

  }

  create_order_id = (session) => {
    const { cid, fid } = session;
    const hash = createHmac('sha1',fid);
    return hash.update(cid).digest('hex');
  }

  update_state = (values) => {
    this.setState({ checkout: values });
  }

  render() {

    const { checkout } = this.state;

    return (
      <section className='Section-Checkout'>

        <Helmet title='Checkout | Adenzo Comfies'/>

        <Navigation/>

        <div className="Section-Checkout-Body">
          <CheckoutForm
            invoice={this.state.invoice}
            update_parent={this.update_state}
          />
          <Products data={this.state.checkout}/>
        </div>

        <Spinner loading={checkout.loading}/>

      </section>
    );
  }
}
